"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var react_router_dom_1 = require("react-router-dom");
var react_fontawesome_1 = require("@fortawesome/react-fontawesome");
require("../Styles/NavButton.css");
var NavButton = /** @class */ (function (_super) {
    __extends(NavButton, _super);
    function NavButton(props) {
        return _super.call(this, props) || this;
    }
    NavButton.prototype.render = function () {
        return (React.createElement(react_router_dom_1.Link, { className: "navbutton" + (this.props.active ? " active" : ""), to: this.props.endpoint },
            this.props.icon != null ?
                React.createElement(react_fontawesome_1.FontAwesomeIcon, { className: "navbutton-icon", icon: this.props.icon })
                :
                    React.createElement("div", { className: "icon-cluster" },
                        React.createElement(react_fontawesome_1.FontAwesomeIcon, { className: "navbutton-icon-sm", icon: this.props.icons }),
                        React.createElement(react_fontawesome_1.FontAwesomeIcon, { className: "navbutton-icon", icon: this.props.icons }),
                        React.createElement(react_fontawesome_1.FontAwesomeIcon, { className: "navbutton-icon-sm", icon: this.props.icons })),
            React.createElement("span", null, this.props.text)));
    };
    return NavButton;
}(React.Component));
exports.NavButton = NavButton;
//# sourceMappingURL=NavButton.js.map